/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {CTALink} from '@ion/dls/src/components/buttons/CTALink';
import Legend from '@ion/dls/src/editors/legend/Legend';
import Opacity from './Opacity';
import Sublayers from './Sublayers';
import {LayerProps} from './types';

const Details = ({
  layer,
  hasSublayers,
  sublayerVisibility,
  opacity,
  classes,
  activeTab,
  isActiveTab,
  updateState,
  onSublayerVisibilityChange,
  changeOpacity
}: LayerProps) => {
  const labels        = translate('maps:operationalLayers', {returnObjects: true});
  const isDefault     = activeTab.length === 0;
  const layerTitle    = layer?.title;
  const isLegend      = isActiveTab({layer: layerTitle, option: 'legend'});
  const isSublayers   = isActiveTab({layer: layerTitle, option: 'sublayers'});
  const showLegend    = isLegend || !hasSublayers;
  const showSublayers = (isSublayers || (isDefault && hasSublayers) || (!isLegend && hasSublayers));
  return (
    <>
      <div className={classes.layers}>
        {hasSublayers &&
          <div className={classes.subLayer}>
            <CTALink className={(isDefault || isSublayers || !isLegend)
              ? classes.buttonSelected : classes.button} onClick={function() {
              updateState([{layer: layerTitle, option: 'sublayers'}]);
            }}>
              {labels?.sublayers}
            </CTALink>
          </div>}
        <div>
          <CTALink className={showLegend
            ? classes.buttonSelected : classes.button} onClick={function() {
            updateState([{layer: layerTitle, option: 'legend'}]);
          }}>
            {labels?.legend}
          </CTALink>
        </div>
      </div>
      {showLegend && <Legend layer={layer} />}
      {showSublayers &&
        <Sublayers sublayers={layer?.layers}
          layerTitle={layerTitle}
          sublayersVisibility={sublayerVisibility}
          onVisibilityChange={onSublayerVisibilityChange}
          opacity={opacity}
          changeOpacity={changeOpacity} />}
      {!hasSublayers &&
      <Opacity changeOpacity={changeOpacity}
        opacity={opacity} title={layerTitle} />}
    </>
  );
};

export default Details;
